import { Button } from 'antd';
import React from 'react'
import ReactExport from "react-export-excel";
import { DownloadOutlined  } from '@ant-design/icons';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default function ExportExcel({data}) {
   return (

       
        <ExcelFile filename="Enquiries" element={<Button icon={<DownloadOutlined/>} className="mb-4" type="primary">Download</Button>}>
                
        <ExcelSheet data={data} name="Enquiries" >
            <ExcelColumn label="email" value={col => col?.email ? col.email: "null"}/> 
            <ExcelColumn label="Name" value ={col => col?.name ? col.name: "null"}/>
            <ExcelColumn label="Phone" value ={col => col?.phone ? col.phone: "null"}/>
            <ExcelColumn label="Country" value ={col => col?.country ? col.country: "null"}/>
            <ExcelColumn label="State" value ={col => col?.state ? col.state: "null"}/>
            <ExcelColumn label="City" value ={col => col?.city ? col.city: "null"}/>
            <ExcelColumn label="Source of Contact" value ={col => col?.source ? col.source: "null"}/>

        </ExcelSheet>
    </ExcelFile>
    )
}